import WeatherApp from './WeatherApp.png'
import Photosite from './Photosite.png'
import Calculator from './Calculator.png'

export const photo = Photosite
export const weather = WeatherApp
export const calculator = Calculator
